import { Reveal } from "./Reveal.tsx";

export function Newsletter() {
  return (
    <section
      aria-label="Newsletter"
      className="relative overflow-hidden border-t border-white/[.07] bg-ink py-20 md:py-28 lg:py-[120px]"
    >
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(60% 80% at 50% 0%,rgba(221,42,2,.13),transparent 60%)" }}
      />
      <Reveal className="relative mx-auto max-w-[760px] px-5 text-center md:px-8 lg:px-12">
        <div className="mb-6 font-mono text-xs uppercase tracking-[.28em] text-flame">The dispatch</div>
        <h2 className="m-0 mb-[22px] font-archivo text-[clamp(32px,8vw,80px)] font-extrabold leading-[.96] tracking-[-.03em]">
          Never miss
          <br />a gathering.
        </h2>
        <p className="mx-auto m-0 mb-10 max-w-[46ch] text-lg leading-[1.6] text-white/[.66]">
          The week's best events near you, the builds worth the drive, and first dibs on tickets — straight to your
          inbox.
        </p>
        <div className="mx-auto mb-[18px] flex max-w-[520px] flex-col items-stretch overflow-hidden rounded-[13px] border border-white/[.18] bg-white/[.05] sm:flex-row">
          <label htmlFor="newsletter-email" className="sr-only">
            Email address
          </label>
          <input
            id="newsletter-email"
            type="email"
            placeholder="you@email.com"
            className="flex-1 bg-transparent px-5 py-[17px] text-[15.5px] text-white placeholder:text-white/45 focus:outline-none"
          />
          <button
            type="button"
            className="m-[7px] rounded-[9px] bg-flame px-[26px] font-archivo text-[15px] font-bold text-white transition hover:bg-flame-dark"
          >
            Subscribe
          </button>
        </div>
        <div className="font-mono text-[11.5px] text-white/40">
          Land · Sea · Air · One email a week · Unsubscribe anytime
        </div>
      </Reveal>
    </section>
  );
}
